import TIM from 'tim-js-sdk';
import { genUserSign } from '@/api/trtc'
import { APPID } from '@/constant'

/**
 * IM 通话类型
 */
export const IM_MSG_TYPE = {
  /** 呼叫 */
  CALL_TO: 1,
  /** 取消呼叫 */
  PRE_HANG_ON: 2,
  /** 通话 结束 */
  CALL_OVER: 3,
  /** 拒绝接听 */
  REJECT: 4,
  /** 接听 */
  ANSWER: 5,
  /** 正忙 */
  BUSY: 6,
  /** 开门 */
  OPEN_DOOR: 7,
  /** 开门成功 */
  OPEN_OK: 8,
  /** 群呼 */
  CALL_TO_MULTI: 9,
  /** 超时 30s */
  TIMEOUT: 10,
  /** 远程开门 */
  ELECTRICAL_OPEN_DOOR: 11,
  /** 局域网对讲接听 */
  RESPONSE: 20,
  /** 局域网对讲信令交换 */
  CANDIDATE: 21,
  /** 局域网对讲提供SDP */
  OFFER: 22,
  /** 局域网对讲已连接 */
  CONNECTED: 23,
};

/**
 * 当前通话状态
 */
export const CALL_STATUS = {
  /** 空闲 */
  FREE: 'free',
  /** 主呼 */
  CALL_TO: 'call_to',
  /** 被呼, 接听 */
  CALLED: 'called',
  /** 通话中 */
  CALLING: 'calling',
}

/** 设备类型 */
export const DEVICE_TYPE = {
  INDOOR: 'indoor',
  MANAGE: 'manage',
  OUTDOOR: 'outdoor',
  WALL: 'wall',
  GATE: 'gate',
  MOBILE: 'mobile',
  WEB: 'web',
}

export const DEVICE_TYPE_TEXT = {
  indoor: '室内机',
  manage: '管理机',
  outdoor: '围墙机/单元机',
  wall: '围墙机',
  gate: '单元机',
  mobile: '手机',
  web: '平台',
}

export const USER_TYPE = {
  '0,1': '平台端/物业APP',
  '0': "平台端", // 0
  '1': "物业APP", // 1-不可开门
  '2': "住户APP", // 2-不可开门
  '3': "室内机", // 3-不可开门
  '4': "单元机", // 4-可开门
  '5': "围墙机", // 5-可开门
  '6': "管理中心机", // 6-不可开门
}

export class Im {
  SDKAppID = APPID;
  tim = null;
  userId = '';
  userSig = '';
  imCallInfo = {
    callGoal: '',
    roomCode: '',
    status: CALL_STATUS.FREE,
    isCallTo: false,
    goalDeviceType: '',
  };
  cbPool = {};

  constructor() {
    this.SDKAppID = APPID
    this.tim = TIM.create({ SDKAppID: APPID })
  }

  async login(userId, userSig) {
    this.userId = userId;
    this.userSig = userSig;
    this.tim.on(TIM.EVENT.MESSAGE_RECEIVED, this.onMessageReceived);
    await this.tim.login({ userID: this.userId, userSig: this.userSig });
  }

  async destroy() {
    this.cbPool = {};
    this.im.off(TIM.EVENT.MESSAGE_RECEIVED, this.onMessageReceived);
    await this.im.destroy();
  }

  onMessageReceived = (event) => {
    console.log('---------------IM消息---------------------')
    console.log(event)
    if (event?.data?.length) {
      for (let i = 0; i < event.data.length; i++) {
        const message = event.data[i]
        const callGoal = message.from
        console.log(message);
        
        if (message.conversationType !== TIM.TYPES.CONV_C2C) {
          return
        }
        
        if (callGoal === this.userId) {
          return
        }

        console.log(message.payload.text);

        const msgData = JSON.parse(message.payload.text)

        const cbList = this.cbPool[TIM.EVENT.MESSAGE_RECEIVED] || [];
        console.log(cbList);
        cbList.forEach(cb => {
          cb({ ...message, ...msgData })
        });
      }
    }
  }

  async sendMessage(toId, payload) {
    console.info(toId, payload);
    const message = this.tim.createTextMessage({
      to: toId,
      conversationType: TIM.TYPES.CONV_C2C,
      payload: payload,
    });
    await this.tim.sendMessage(message, {
      // 如果接收方不在线，则消息将存入漫游，且进行离线推送（在接收方 App 退后台或者进程被 kill 的情况下）。接入侧可自定义离线推送的标题及内容
      offlinePushInfo: {
        title: '收到云对讲呼叫', // 离线推送标题
        description: '点击消息打开App 接听…', // 离线推送内容
        // androidOPPOChannelID: '' // 离线推送设置 OPPO 手机 8.0 系统及以上的渠道 ID
      }
    });
  }

  on(type, cb) {
    const cbList = this.cbPool[type] || []
    if (cbList.indexOf(cb) === -1) {
      cbList.push(cb)
    }
    this.cbPool[type] = cbList
  }

  off(type, cb) {
    const cbList = this.cbPool[type] || []

    const index = cbList.indexOf(cb)
    if (index > -1) {
      cbList.splice(index, 1)
    }

    this.cbPool[type] = cbList
  }
}
